import { SyncClient, Client } from 'twilio-sync'
import { SyncDocument, SyncMap } from 'twilio-sync'
import { twilioUIDataDefaultState, twilioBookingDataDefaultState } from '../../dataStore/reducers/docs/defaultState'
import isEmpty from 'lodash/isEmpty'
import { debug } from '@bt-react/libs/Logger'

/** Will fetch or create document. If it is creating the document, it will set up the default values passed */
export async function fetchOrCreateDocument (client: Client, documentName: string, defaultState = {}): Promise<SyncDocument> {

  /** If no default state has been passed, revert to default behaviour */
  if (isEmpty(defaultState)) {

    return client.document(documentName)

  }

  /** Attempt to fetch a document if it exists then return it */
  try {

    const document = await client.document({
      id: documentName,
      mode: 'open_existing'
    })

    return document

  }
  catch (e) {

    console.log(`${e}`, documentName)

  }

  /** If no document was found and we have a default state, create the document with the default state and return it */
  try {

    const document = await client.document({
      id: documentName,
      mode: 'create_new',
      data: defaultState
    })

    return document

  }
  catch (e) {

    console.log(e)

  }

  throw new Error(`Failed to either fetch or create ${documentName}`)

}

export async function fetchMap (client: SyncClient, documentName: string): Promise<SyncMap> {

  try {

    return client.map(documentName)

  }
  catch (e) {

    debug(e.message)

  }

  throw new Error(`Failed to fetch ${documentName}`)

}

/**
 * Instantiates and returns Twilio Sync documents
 */
export default (client: Client, roomname: string): Promise<(SyncDocument | SyncMap)[]> =>
  Promise.all([
    fetchOrCreateDocument(client, `${roomname}-ui`, twilioUIDataDefaultState),
    fetchOrCreateDocument(client, `${roomname}`, twilioBookingDataDefaultState),
    fetchOrCreateDocument(client, `${roomname}-play-in`),
    fetchOrCreateDocument(client, `${roomname}-bridgedata`),
    fetchOrCreateDocument(client, `${roomname}-backend-doc`),
    fetchOrCreateDocument(client, `${roomname}-conversations`),
    fetchMap(client, `${roomname}-seating-order`)
  ])
